import {
  CreateDateColumn,
  UpdateDateColumn,
  Entity,
  Index,
  Column,
  RelationId,
  ManyToOne,
  PrimaryGeneratedColumn
} from 'typeorm'
import { ObjectType, Field, Int, ID, registerEnumType } from 'type-graphql'

import { Domain } from '@things-factory/shell'
import { User } from '@things-factory/auth-base'

export interface SettingCategory {
  name: string
  propType: string
}

var SettingCategories: { [name: string]: SettingCategory } = {}

@Entity()
@Index('ix_setting_0', (setting: Setting) => [setting.domain, setting.name], { unique: true })
@Index('ix_setting_1', (setting: Setting) => [setting.domain, setting.category])
@ObjectType({ description: 'Entity for Setting' })
export class Setting {
  static registerSettingCategory(settingType: SettingCategory) {
    SettingCategories[settingType.name] = settingType
  }

  static getSettingCategory(name: string) {
    return SettingCategories[name]
  }

  @PrimaryGeneratedColumn('uuid')
  @Field(type => ID)
  readonly id: string

  @ManyToOne(type => Domain)
  @Field(type => Domain)
  domain?: Domain

  @RelationId((setting: Setting) => setting.domain)
  domainId?: string

  @Column()
  @Field()
  name: string

  @Column({
    nullable: true
  })
  @Field({ nullable: true })
  description?: string

  @Column()
  @Field()
  category: string

  @Column({ nullable: true })
  @Field({ nullable: true })
  value?: string

  @CreateDateColumn()
  @Field({ nullable: true })
  createdAt?: Date

  @UpdateDateColumn()
  @Field({ nullable: true })
  updatedAt?: Date

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  creator?: User

  @RelationId((setting: Setting) => setting.creator)
  creatorId?: string

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  updater?: User

  @RelationId((setting: Setting) => setting.updater)
  updaterId?: string
}
